import React, { useState, useEffect, useContext } from "react"
import axios from 'axios'

import { GlobalContext, HOST } from "./context/GlobalContext"

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Table from 'react-bootstrap/Table'
import Form from 'react-bootstrap/Form'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import Offcanvas from 'react-bootstrap/Offcanvas'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

import './App.css'
import { ArrowLeftRight, Basket2Fill } from "react-bootstrap-icons"

const ALMACEN_API = HOST + '/api/inv/librosAlmacen/'
const ALMACEN_UPDATE_API = HOST + '/api/inv/librosAlmacen/update'
const ALMACEN_TRANSFER_API = HOST + '/api/inv/librosAlmacen/transfer'
const ALMACEN_OUT_API = HOST + '/api/inv/librosAlmacen/salida'

function LibroAlmacen({ idLibro }) {
  const { setGlobalLoading, setMailBody, setMailTitle, setShowMesage, getNombreAlmacen, getNombreLibro, almacenList, token, rol } = useContext(GlobalContext);

  const [ libroAlmacenList, setLibroAlmacenList ] = useState([])

  const [ show, setShow ] = useState(false)
  const [ showAdd, setShowAdd ] = useState(false)
  const [ showOut, setShowOut ] = useState(false)
  const [ action, setAction ] = useState('Crear Proveedor')

  const [ idAlmacen, setIdAlmacen ] = useState()
  const [ toAdd, setToAdd ] = useState()

  const [ fecha, setFecha ] = useState()
  const [ idAlmacenSalida, setIdAlmacenSalida ] = useState()
  const [ idAlmacenEntrada, setIdAlmacenEntrada ] = useState()
  const [ cantidad, setCantidad ] = useState()
  const [ unidad, ] = useState('Pza')
  const [ precio, setPrecio ] = useState(0)
  const [ estatus, ] = useState(true)

  useEffect(() => {
    setGlobalLoading( true )
    getLibroAlmacenes()
    setPrecio(getNombreLibro(idLibro).precio)
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getLibroAlmacenes = () => {
    axios({
      method: 'get',
      url: ALMACEN_API + idLibro,
      headers: { 'Authentication': token }
    })
    .then(result => {
      console.log("almacenes", result.data)
      let data = result.data

      /*data.sort(function (a, b) {
        return a.libroAlmacenPK.idAlmacen > b.libroAlmacenPK.idAlmacen;
      });
      console.log("data sort", data)*/

      setLibroAlmacenList( data )
      setGlobalLoading( false )
    })
    .catch(error => {
      console.log("error", error.message)
      setGlobalLoading( false )
    })
  }

  const showForm = (item) => {

    if( item ){
      setAction('Actualizar Libro en Almacén')
      setIdAlmacen(item.libroAlmacenPK.idAlmacen)
      setCantidad(item.cantidad)
    } else {
      setAction('Nuevo Libro en Almacén')
      setIdAlmacen(null)
      setCantidad(0)
    }

    setShow(true)
  }

  const showModal = (item) => {
    setIdAlmacen(item.libroAlmacenPK.idAlmacen)
    setCantidad(item.cantidad)
    setToAdd()

    setIdAlmacenSalida(item.libroAlmacenPK.idAlmacen)
    setShowAdd(true)
  }

  const showOutForm = (item) => {
    setIdAlmacen(item.libroAlmacenPK.idAlmacen)
    setCantidad(item.cantidad)
    setToAdd()

    setIdAlmacenSalida(item.libroAlmacenPK.idAlmacen)
    setShowOut(true)
  }

  const updateItem = (e) => {
    e.preventDefault();
    setGlobalLoading( true )

    var json = { libroAlmacenPK: { idLibro: idLibro, idAlmacen: idAlmacen }, cantidad: parseInt(cantidad) }

    console.log('json to update libro almacen', json)

    axios.post(ALMACEN_UPDATE_API, json, {
			headers: { 'content-type': 'application/json', 'Authentication': token }
    }).then(result => {
      console.log("result update", result.data)
      getLibroAlmacenes()
      setToAdd()
      setShow(false)
      closeAddLibros()
      setGlobalLoading( false )
    })
    .catch(error => {
      console.log("error", error.message)
      setShowMesage(true)
      setMailTitle('Error')
      setMailBody('Ocurrió un error al guardar tu registro. Por favor intentalo mas tarde.')
      setGlobalLoading( false )
    })
  }

  const updateOutProduct = (e) => {
    e.preventDefault();
    setGlobalLoading( true )

    var json = { 
      idTraspaso: null,
      fecha: fecha,
      idalmacensalida: idAlmacenSalida,
      idalmacenentrada: null,
      idlibro: idLibro,
      cantidad: toAdd,
      unidad: unidad,
      precio: precio,
      estatus: estatus,
      usuarioRegistra: null,
      fechaRegistra: null
    }
    
    console.log('json to create traspaso', json)

    axios.post(ALMACEN_OUT_API, json, {
      headers: { 'content-type': 'application/json', 'Authentication': token }
    }).then(result => {
      console.log("result update", result.data)
      getLibroAlmacenes()
      setToAdd(0)
      setShow(false)
      closeOutLibros()
      setGlobalLoading( false )
    })
    .catch(error => {
      console.log("error", error.message)
      setShowMesage(true)
      setMailTitle('Error')
      setMailBody('Ocurrió un error al guardar tu registro. Por favor intentalo mas tarde.')
      setGlobalLoading( false )
    })
  }

  const createTransfer = (e) => {
    e.preventDefault();
    setGlobalLoading( true )

    var json = { 
      idTraspaso: null,
      fecha: fecha,
      idalmacensalida: idAlmacenSalida,
      idalmacenentrada: idAlmacenEntrada,
      idlibro: idLibro,
      cantidad: toAdd,
      unidad: unidad,
      precio: precio,
      estatus: estatus,
      usuarioRegistra: null,
      fechaRegistra: null
    }
    
    console.log('json to create traspaso', json)

    axios.post(ALMACEN_TRANSFER_API, json, {
			headers: { 'content-type': 'application/json', 'Authentication': token }
    }).then(result => {
      console.log("result update", result.data)
      getLibroAlmacenes()
      setToAdd(0)
      setShow(false)
      closeAddLibros()
      setGlobalLoading( false )
    })
    .catch(error => {
      console.log("error", error.message)
      setShowMesage(true)
      setMailTitle('Error')
      setMailBody('Ocurrió un error al guardar tu registro. Por favor intentalo mas tarde.')
      setGlobalLoading( false )
    })
  }

  const closeAddLibros = () => {
    setShowAdd(false)
    setToAdd()
  }

  const closeOutLibros = () => {
    setShowOut(false)
    setToAdd()
  }

  return (
    <>
      <Offcanvas show={showAdd} onHide={ closeAddLibros } placement={'end'}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className="title-form"> Traspaso de Almacenes </div>
            <div className="desc-form"> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form onSubmit={ createTransfer }>
            
            <Form.Group className='mb-3'>
              <FloatingLabel label="Fecha">
                <Form.Control required type="date" name="fecha" max={new Date().toISOString().split("T")[0]} value={ fecha } placeholder="" onChange={ (e) => setFecha( e.target.value ) }/>
              </FloatingLabel>
            </Form.Group>

            <Form.Group className='mb-3'>
              <FloatingLabel label="Almacén de salida">
                <Form.Select required name="idAlmacenSalida" value={ idAlmacenSalida } onChange={ (e) => setIdAlmacenSalida( e.target.value ) }>
                  <option>Selecciona una opción</option>
                  { almacenList.map( item => (
                    <option key={ item.idAlmacen } value={ item.idAlmacen }>{ item.almacen }</option>
                  ))}
                </Form.Select>
              </FloatingLabel>
            </Form.Group>

            <Form.Group className='mb-3'>
              <FloatingLabel label="Almacén de entrada">
                <Form.Select required name="idAlmacenEntrada" value={ idAlmacenEntrada } onChange={ (e) => setIdAlmacenEntrada( e.target.value ) }>
                  <option>Selecciona una opción</option>
                  { almacenList.map( item => (
                    <option key={ item.idAlmacen } value={ item.idAlmacen }>{ item.almacen }</option>
                  ))}
                </Form.Select>
              </FloatingLabel>
            </Form.Group>

            <Form.Group className='mb-3'>
              <FloatingLabel label="Cantidad">
                <Form.Control required type='number' name="toAdd" value={ toAdd } onChange={ (e) => setToAdd( e.target.value ) } placeholder="" />
              </FloatingLabel>
            </Form.Group>

            <button type="button" className="cancel-btn" onClick={ closeAddLibros } >{ 'Cancelar' }</button>&nbsp;&nbsp;
            <button type="submit" className="grl-btn">{ 'Agregar' }</button>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas show={showOut} onHide={ closeOutLibros } placement={'end'}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className="title-form"> Ajuste de producto </div>
            <div className="desc-form"> Podemos ajustar el inventario para dar salida o entrada manual al artículo. Usa numeros positivos para dar entrada a artículos y números negativos para dar salida.  </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form onSubmit={ updateOutProduct }>
            
            <Form.Group className='mb-3'>
              <FloatingLabel label="Fecha">
                <Form.Control required type="date" name="fecha" max={new Date().toISOString().split("T")[0]} value={ fecha } placeholder="" onChange={ (e) => setFecha( e.target.value ) }/>
              </FloatingLabel>
            </Form.Group>

            <Form.Group className='mb-3'>
              <FloatingLabel label="Almacén de salida">
                <Form.Select required disabled name="idAlmacenSalida" value={ idAlmacenSalida } onChange={ (e) => setIdAlmacenSalida( e.target.value ) }>
                  <option>Selecciona una opción</option>
                  { almacenList.map( item => (
                    <option key={ item.idAlmacen } value={ item.idAlmacen }>{ item.almacen }</option>
                  ))}
                </Form.Select>
              </FloatingLabel>
            </Form.Group>

            <Form.Group className='mb-3'>
              <FloatingLabel label="Cantidad">
                <Form.Control required type='number' name="toAdd" value={ toAdd } onChange={ (e) => setToAdd( e.target.value ) } placeholder="" />
              </FloatingLabel>
            </Form.Group>

            <button type="button" className="cancel-btn" onClick={ closeOutLibros } >{ 'Cancelar' }</button>&nbsp;&nbsp;
            <button type="submit" className="grl-btn">{ 'Guardar' }</button>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas show={show} onHide={ () => setShow(false) } placement={'end'}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className="title-form">{ action }</div>
            <div className="desc-form"> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form id="almacenForm" onSubmit={ updateItem }>
            <Container>
              <Row>
                <div>
                  <input type="hidden" name="idLibro" value={ idLibro } />
                  <Container>
                    <Row>
                      <Col md="6">
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="Almacenes">
                            <Form.Select required name="idAlmacen" value={ idAlmacen } onChange={ (e) => setIdAlmacen( e.target.value ) }>
                              <option>Selecciona una opción</option>
                              { almacenList.map( item => (
                                <option key={ item.idAlmacen } value={ item.idAlmacen }>{ item.almacen }</option>
                              ))}
                            </Form.Select>
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                      <Col md="6">
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="Cantidad">
                            <Form.Control required type='number' name="cantidad" value={ cantidad } onChange={ (e) => setCantidad( e.target.value ) } placeholder="" />
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Container>
                  
                  <br/>
                  <div align="center">
                    <button type="button" className="cancel-btn" onClick={ () => setShow(false) } >{ 'Cancelar' }</button>&nbsp;&nbsp;
                    <button type="submit" className="grl-btn">{ 'Guardar' }</button>
                  </div>
                </div>
              </Row>
            </Container>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>

      <Container className='main-component'>
        <Row>
          <Col md={ 3 }>
          </Col>
          <Col md={ 9 } align="right">
            { parseInt(rol) === 2 && 
              <>
                <span className="single-btn" onClick={ () => showForm() } > Nuevo </span>
              </>
            }
          </Col>
        </Row>
        <br/>
        <Row>
          <Col>
            <Table responsive>
              <thead>
                <tr>
                  <th>Almacén</th>
                  <th>Existencias</th>
                  { parseInt(rol) === 2 &&  <th></th> }
                </tr>
              </thead>
              <tbody>
                { libroAlmacenList.length === 0 && 
                  <tr>
                    <td colSpan="6"> <div>Sin registros</div> </td>
                  </tr>
                }
                { libroAlmacenList.map( item => (
                  <tr key={ item.libroAlmacenPK.idAlmacen }>
                    <td> 
                      { getNombreAlmacen(item.libroAlmacenPK.idAlmacen).almacen }
                    </td>
                    <td> 
                      { `${item.cantidad} pzas` }
                    </td>
                    { parseInt(rol) === 2 && 
                      <td align="right"> 
                        <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Ajuste de Producto</Tooltip>}>
                          <Basket2Fill onClick={ () => showOutForm(item) } className="table-icon" />
                        </OverlayTrigger>
                        <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Traspasar</Tooltip>}>
                          <ArrowLeftRight onClick={ () => showModal(item) } className="table-icon" />
                        </OverlayTrigger>
                        {/* <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Editar</Tooltip>}>
                          <PencilFill onClick={ () => showForm(item) } className="table-icon" />
                        </OverlayTrigger> */}
                      </td>
                    }
                  </tr>
                )) }
              </tbody>
            </Table>
          </Col>
        </Row>
      </Container>

    </>
  );
}

export default LibroAlmacen;
